require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-145-calendar-view.json") })
        }
      }, "path---article-145-calendar-view");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-145-calendar-view!./.cache/json/article-145-calendar-view.json
// module id = 495
// module chunks = 231608221292675